import { useMutation, useQueryClient } from '@tanstack/react-query';

import { notifyMeta } from '@/lib/notify';
import { authService } from '@/services/auth';
import { errorUtils } from '@/services/errors';

const useSignOut = () => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, void>({
    meta: notifyMeta('authSignOut'),
    mutationFn: async () => {
      errorUtils.unwrap(await authService.signOut());
    },
    onSettled: () => {
      queryClient.clear();
    },
  });
};

export {
  useSignOut,
};
